import { palette } from "../theme/palette";

export const ALLOCATED = "ALLOCATED";
export const UNALLOCATED = "UNALLOCATED";
export const ALL = "ALL";
export const MULTI = "MULTI";

export const DEFAULT_LABEL_CHANGES = {
  OUTER: {},
  SECTOR: {},
  POSTCODE: {},
};

export const RESET_CONFIG = {
  colour: null,
  plannedReadyTime: null,
  postcode: null,
  route: null,
  routeCode: null,
  sector: null,
  totalStops: null,
};

export const ROUTE_CARD_PADDING = 3;

export const ROUTE_STATUS = {
  DEFAULT: 0,
  OK: 1,
  DUTY_EXCEEDED: 2,
  OPPORTUNITY: 3,
};

export const DEFAULT_ROUTE = {
  colour: null,
  driverCode: null,
  outer: [],
  routeOptimisation: null,
  overrideAllocated: false,
  plannedReadyTime: null,
  plannedReadyTimeAsString: null,
  postcode: [],
  routeCode: null,
  routeType: null,
  sectionCode: null,
  sector: [],
  stops: [],
  textColour: palette.typography.white.high,
};
